import { ActionTypeEnum } from '@empathybroker/tsclient-play/dist/enums/action-type.enum';

export enum YearlySummaryFeatureIdEnum {
  YEARLY_SUMMARY = 'yearly_summary'
}

export enum AnalyticsFeatureIdEnum {
  ANALYTICS = 'analytics',
  OVERALL = 'overall',
  QUERIES = 'queries'
}

export enum InsightsFeatureIdEnum {
  INSIGHTS = 'insights',
  NOW = 'now',
  ORIGINS = 'origins',
  KEYWORDS = 'keywords'
}

export enum PlayRootFeatureIdEnum {
  PLAY = 'play'
}

export enum PlayChildFeatureIdEnum {
  PRODUCTS_RANKING = 'productsRanking',
  ATTRIBUTES_RANKING = 'attributesRanking',
  FACETS_CONFIG = 'facetsConfig',
  RELATED_TAGS = 'relatedTags' // TODO: remove once we have the new version of tsclient-play
}

export enum DashboardFeatureIdEnum {
  EQUALIZE_DASHBOARD = 'equalizeDashboard',
  SYNONYM_DASHBOARD = 'synonymDashboard'
}

export const PlayFeatureIdEnum = { ...PlayRootFeatureIdEnum, ...ActionTypeEnum, ...PlayChildFeatureIdEnum, ...DashboardFeatureIdEnum };
export type PlayFeatureIdEnum = (PlayRootFeatureIdEnum | ActionTypeEnum | PlayChildFeatureIdEnum | DashboardFeatureIdEnum);

export enum ExplainFeatureIdEnum {
  EXPLAIN = 'explain'
}

export enum AuditFeatureIdEnum {
  AUDIT = 'audit'
}

export enum IndexFeatureIdEnum {
  INDEX = 'index'
}

export enum AdminFeatureIdEnum {
  ADMIN = 'admin',
  PERMISSIONS = 'permissions',
  FILTERS = 'filters',
  KPIS = 'kpis',
  CATALOG = 'catalog',
  TOOLS = 'tools',
  USERS = 'users'
}

export enum AccountFeatureIdEnum {
  ACCOUNT = 'account'
}

export const FeatureIdEnum = {
  ...YearlySummaryFeatureIdEnum,
  ...AnalyticsFeatureIdEnum,
  ...InsightsFeatureIdEnum,
  ...PlayFeatureIdEnum,
  ...ExplainFeatureIdEnum,
  ...AuditFeatureIdEnum,
  ...IndexFeatureIdEnum,
  ...AdminFeatureIdEnum,
  ...AccountFeatureIdEnum
};
export type FeatureIdEnum = (
  YearlySummaryFeatureIdEnum
  | AnalyticsFeatureIdEnum
  | InsightsFeatureIdEnum
  | PlayFeatureIdEnum
  | ExplainFeatureIdEnum
  | AuditFeatureIdEnum
  | IndexFeatureIdEnum
  | AdminFeatureIdEnum
  | AccountFeatureIdEnum);
